export { RegisterPageBannerSection } from "./RegisterPageBannerSection";
export { RegisterPageFormSection } from "./RegisterPageFormSection";
